import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'
import { formatISO } from 'date-fns'
import { v4 as uuid } from 'uuid'

import { graphyteTrack } from 'analyticActions/graphyte/events'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import {
  getGraphyteEnabledSelector,
  getUserFirstPurchaseSelector,
  getUserIdSelector,
} from 'store/modules/user/selectors'
import type { TypedThunk } from 'store/types'

export const graphyteTrackGamePlay =
  (gameProduct: GameProduct, options?: { [key: string]: string | string[] | number }): TypedThunk =>
  (dispatch, getState) => {
    const userFirstPurchase = getUserFirstPurchaseSelector(getState())
    const userId = getUserIdSelector(getState())
    const activeCurrencyId = getActiveCurrencyIdSelector(getState())
    const purchaserUser = userFirstPurchase ? 1 : 0
    const graphyteEnabled = getGraphyteEnabledSelector(getState())

    if (graphyteEnabled) {
      graphyteTrack('GAME_PLAY', {
        event_type: 'Gaming',
        event_uuid: uuid(),
        event_datetime: formatISO(new Date()),
        event_value: purchaserUser,
        event_info_1: gameProduct.code,
        event_info_2: gameProduct.title,
        event_info_3: gameProduct.type,
        userid: userId,
        event_ccy: activeCurrencyId,
        ...options,
      })
    }
  }

export const graphyteTrackGameClose =
  (gameProduct: GameProduct): TypedThunk =>
  (dispatch, getState) => {
    const userFirstPurchase = getUserFirstPurchaseSelector(getState())
    const userId = getUserIdSelector(getState())
    const activeCurrencyId = getActiveCurrencyIdSelector(getState())
    const purchaserUser = userFirstPurchase ? 1 : 0
    const graphyteEnabled = getGraphyteEnabledSelector(getState())

    if (graphyteEnabled) {
      graphyteTrack('GAME_CLOSE', {
        event_type: 'Gaming',
        event_uuid: uuid(),
        event_datetime: formatISO(new Date()),
        event_value: purchaserUser,
        event_info_1: gameProduct.code,
        event_info_2: gameProduct.title,
        event_info_3: gameProduct.type,
        userid: userId,
        event_ccy: activeCurrencyId,
      })
    }
  }
